var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "w-100" }, [
    _c("div", { staticClass: "card-header bg-transparent pb-4 border-0" }, [
      _c(
        "div",
        { staticClass: "logo-center text-center mb-4 pb-4 border-bottom" },
        [_c("logo")],
        1
      ),
      _c(
        "form",
        { attrs: { role: "form" } },
        [
          _c("base-input", {
            staticClass: "mb-3",
            attrs: {
              alternative: "",
              "prepend-icon": "ni ni-email-83",
              placeholder: "Enter Verification code",
            },
            model: {
              value: _vm.code,
              callback: function ($$v) {
                _vm.code = $$v
              },
              expression: "code",
            },
          }),
          _vm.$v.code.$error
            ? _c("div", { staticClass: "error field" }, [
                _vm._v("Valid verification code is required"),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "base-button",
                {
                  staticClass: "my-4 btn-block",
                  attrs: { type: "primary" },
                  on: { click: _vm.handleRegistration },
                },
                [_vm._v("Verify")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }